import {
  Component,
  Input,
  OnInit,
  ChangeDetectionStrategy,
  inject,
} from '@angular/core';
import { UntypedFormGroup, FormGroupDirective, FormsModule, ReactiveFormsModule } from '@angular/forms';
import { InvalidErrorStateMatcher } from 'src/app/shared/utils/errorstate-matcher';
import { MatFormField, MatLabel, MatInput, MatError } from '@angular/material/input';
import { RestrictDollarDecimalPointDirective } from '../../../../../../shared/directives/restrict-dollar-decimal-point.directive';
import { RestrictPercentDecimalPointDirective } from '../../../../../../shared/directives/restrict-percent-decimal-point.directive';

@Component({
  selector: 'app-text-field',
  templateUrl: './text-field.component.html',
  styleUrls: ['./text-field.component.css'],
  changeDetection: ChangeDetectionStrategy.Eager,
  imports: [FormsModule, ReactiveFormsModule, MatFormField, MatLabel, MatInput, RestrictDollarDecimalPointDirective, RestrictPercentDecimalPointDirective, MatError],
})
export class TextFieldComponent implements OnInit {
  private rootFormGroup = inject(FormGroupDirective);

  @Input() public label: string;
  @Input() public datacy: string;
  @Input() public placeholder: string;
  @Input() public id: string = 'name';
  @Input() public controlName: string;
  @Input() public required: boolean;
  @Input() public class: string;
  @Input() public errorState: InvalidErrorStateMatcher;
  @Input() public type: string;
  @Input() public value: string;
  @Input() public restrictDollarDecimalPoint = false;
  @Input() public restrictPercentDecimalPoint = false;
  public form: UntypedFormGroup;

  public ngOnInit(): void {
    this.form = this.rootFormGroup.control;
  }
}
